var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.a79a84120462d30a65cf58929a9e0bed.svg#b';
                    var viewUrl = 'sprites.a79a84120462d30a65cf58929a9e0bed.svg#view-b';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 27 26',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };